export enum ECommerceProductWizardStep {
  PRODUCT = 'product',
  DESIGN = 'design',
  MEDIA = 'media',
  DETAILS = 'details',
  PRICES = 'prices',
  CONNECT = 'connect',
}
